<template>
	<div
class="sidebar flex flex-col z-40 min-h-screen pt-4 px-6 gap-y-5 overflow-y-auto bg-white shadow-lg lg:shadow-none duration-200"
		:class="stateClasses" data-testid="sidebar">
		<nav class="flex flex-1 flex-col">
			<ul role="list" class="flex flex-1 flex-col gap-y-4">
				<li>
					<ul role="list" class="-mx-2 space-y-1">
						<app-sidebar-menu :items="main" :compact="!appStore.sidebar && desktop" />
					</ul>
				</li>
				<li>
					<!-- <div class="text-xs font-semibold leading-6 text-indigo-200">Your teams</div> -->
					<ul role="list" class="-mx-2 pt-4 space-y-1 border-t border-gray-300">
						<app-sidebar-menu :items="cat2" :compact="!appStore.sidebar && desktop" />
					</ul>
				</li>
			</ul>
		</nav>
	</div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import AppSidebarMenu from './AppSidebarMenu.vue'
import useAppStore from '@/stores/app'
import useAuthStore from '@/stores/auth'
import router from '@/router'

const appStore = useAppStore()
const authStore = useAuthStore()

const desktop = computed(() => {
	return window.innerWidth > 1024
})

const stateClasses = computed(() => {
	let classes = ''

	if (desktop.value) {
		if (appStore.sidebar) {
			classes = 'expanded max-w-[250px]'
		} else {
			classes = 'collapsed max-w-max'
		}

		classes = classes + ' relative w-full'
	} else {
		if (appStore.sidebar) {
			classes = 'expanded'
		} else {
			classes = 'collapsed -translate-x-full'
		}

		classes = classes + ' fixed w-3/4 transition-transform'
	}

	return classes
})

function canAccess(route: string): boolean {
	const permissions = router.resolve({ name: route }).meta.permissions

	if (Array.isArray(permissions)) {
		return authStore.isAbleTo(permissions)
	} else {
		console.error('Invalid route permissions')
		return false
	}
}

function isRouteName(route: string): boolean {
	return router.currentRoute.value.name === route
}

function isRouteGroup(group: string): boolean {
	return router.currentRoute.value.meta.group === group
}

const main = ref([
	{
		name: 'Dashboard',
		href: '/',
		icon: 'fa-solid fa-gauge',
		current: isRouteName('dashboard'),
		visible: true
	},
	{
		name: 'Product Data',
		href: '/product-data/product-categories',
		icon: 'fa-solid fa-info-circle',
		current: isRouteGroup('product-data'),
		visible: true
	},
	{
		name: 'Stock Checker',
		href: '/stock/checker',
		icon: 'fa-solid fa-map-marker',
		current: isRouteName('stock-checker'),
		visible: true
	},
	{
		name: 'Stock Shortage Requests',
		href: '/stock/shortage-requests',
		icon: 'fa-solid fa-clipboard-check',
		current: isRouteName('stock-shortage-requests'),
		visible: true
	},
	{
		name: 'Stock Check Requests',
		href: '/stock/stock-check-requests',
		icon: 'fa-solid fa-list',
		current: isRouteName('stock-check-requests'),
		visible: canAccess('stock-check-requests')
	}
])

const cat2 = ref([
	{
		name: 'Hire Desk',
		href: '/hire-desk',
		icon: 'fa-solid fa-desktop',
		current: isRouteGroup('hire-desk'),
		visible: canAccess('hire-desk')
	},
	{
		name: 'Yard',
		href: '/yard',
		icon: 'fa-solid fa-warehouse',
		current: isRouteGroup('yard-workspace'),
		visible: canAccess('yard')
	},
	{
		name: 'Yard App',
		href: '/yard-app',
		icon: 'fa-solid fa-tablet',
		current: isRouteGroup('yard-app'),
		visible: canAccess('yard-app-dashboard')
	},
	{
		name: 'Journey Planner',
		href: '/journey-planner',
		icon: 'fa-solid fa-route',
		current: isRouteName('journey-planner'),
		visible: canAccess('journey-planner')
	},
	{
		name: 'Files',
		href: '/files',
		icon: 'fa-solid fa-folder',
		current: isRouteName('files'),
		visible: canAccess('hire-desk')
	},
	{
		name: 'Stock Take',
		href: '/stocktake-app',
		icon: 'fa-solid fa-clipboard',
		current: isRouteName('stocktake-app') || isRouteName('stockitems'),
		visible: canAccess('stockitems')
	},

	{
		name: 'Marketing Lists',
		href: '/marketing-lists',
		icon: ['fab', 'mailchimp'],
		current: isRouteName('marketing-lists'),
		visible: canAccess('marketing-lists')
	}
])
</script>
